import { render } from "./DocumentStatistik.vue?vue&type=template&id=546360c1"
import script from "./DocumentStatistik.vue?vue&type=script&lang=js"
export * from "./DocumentStatistik.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__